import { computed } from 'vue';
import { useCurrentUserQuery, UserType } from '@/generated/graphql';
import {
	APOLLO_PARAMS_PERSISTED_QUERY,
	usePersistedQueryLoading,
} from '@/lib/apollo';

export const useCurrentUser = () => {
	const { result, loading } = usePersistedQueryLoading(
		useCurrentUserQuery({
			...APOLLO_PARAMS_PERSISTED_QUERY,
		})
	);

	const currentUser = computed(() => result.value?.CurrentUser);

	const isCUPOUser = computed(
		() => currentUser.value?.type === UserType.Cupo
	);

	const isAdmin = computed(() => currentUser.value?.type === UserType.Admin);

	const permissionSetName = computed(
		() => currentUser.value?.permissionSet?.name
	);

	return {
		loading,
		currentUser,
		isCUPOUser,
		isAdmin,
		permissionSetName,
	};
};
